// ─── Content ──────────────────────────────────────────────────────────────────
export function Content({ children }) {
  return <main className="admin_contents">{children}</main>;
}
